import React, { useEffect } from 'react'

import useCognitoAuthToken from 'hooks/useCognitoAuthToken'

import Environment from 'helpers/environment'
import WindowLocation from 'helpers/windowLocation'

import Api from 'services/api'

import { NoData, SinglePanePage } from 'styles/shared'

const SIGNOUT_TIMEOUT = 10

const YouDontHavePermission = () => {
  const { authToken, isAuthTokenLoaded } = useCognitoAuthToken()

  useEffect(() => {
    window.setTimeout(() => {
      if (Environment.isAWSCognito()) {
        const redirectUrl = WindowLocation.protocol() + '//' + WindowLocation.hostname() + '/signout'
        const signoutUrl = `${Environment.signOutURL()}?post_logout_redirect_uri=${redirectUrl}`

        WindowLocation.replace(signoutUrl)
      } else if (authToken) {
        WindowLocation.replace(Api.Session.logout(authToken))
      }
    }, SIGNOUT_TIMEOUT * 1000)
  }, [authToken])

  if (!isAuthTokenLoaded) {
    return null
  }

  return (
    <SinglePanePage>
      <NoData>
        <h1>You don't have permission to view this site.</h1>
        <h2>You will be signed out and redirected to the sign in screen momentarily</h2>
      </NoData>
    </SinglePanePage >
  )
}

export default YouDontHavePermission
